// JS
// require("devise/login-3.js");
// require("devise/login-general.js");
require("metronic/_theme/js/pages/custom/login/login-general");
// Main Stylesheet
// require("devise/login-3.css");
require("metronic/_theme/sass/pages/login/login-3.scss");
